import { useContext } from 'react'
import { QueryKey, useQuery } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import ApiContext from '../../context/ApiContext'
import { Product } from '../../models/Product'

export const getProductByPriceIdQueryKey = (priceId: string): QueryKey => ['product', priceId]

interface UseProductByPriceIdResult {
	product: Product | undefined
	isLoading: boolean
	error: Error | null
}

const useProductByPriceId = (priceId: string | null): UseProductByPriceIdResult => {
	const auth = getAuth()
	const apiContext = useContext(ApiContext)

	const {
		data: product,
		isLoading,
		error,
	} = useQuery({
		queryKey: priceId ? getProductByPriceIdQueryKey(priceId) : ['product', 'disabled'],
		queryFn: async (): Promise<Product> => {
			if (!priceId) {
				throw new Error('Price ID is required')
			}
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(`${apiContext.apiUrl}/products/price/${priceId}`, {
				headers: {
					Authorization: `Bearer ${idToken}`,
				},
			})

			if (!response.ok) {
				throw new Error(await response.text())
			}
			return response.json()
		},
		enabled: !!priceId,
	})

	return { product, isLoading, error }
}

export default useProductByPriceId
